import React from 'react'
import { motion } from 'framer-motion'
import { Zap, Languages, ShieldCheck, BarChart2, Plug } from 'lucide-react'
import { useT } from '@/context/TranslateCtx'

const items = [
  { k: 'zap', icon: Zap, img: 'Zap.jpg', bg: 'from-primary via-primary' },
  { k: 'lang', icon: Languages, img: 'Languages.jpg', bg: 'from-info via-primary to-secondary' },
  { k: 'secure', icon: ShieldCheck, img: 'ShieldCheck.jpg', bg: 'from-success via-success' },
  { k: 'chart', icon: BarChart2, img: 'BarChart2.jpg', bg: 'from-warning via-warning' },
  { k: 'plug', icon: Plug, img: 'Plug.jpg', bg: 'from-info via-info' },
]

const card = {
  hidden: { opacity: 0, y: 50, scale: 0.9 },
  visible: { opacity: 1, y: 0, scale: 1, transition: { type: 'spring', stiffness: 120, damping: 20 } }
}

export default function Features() {
  const { t } = useT()

  return (
    <section id="features" className="relative bg-white py-32">
      <div className="absolute top-0 left-0 w-full h-20 bg-gradient-to-b from-gray-100 to-transparent pointer-events-none" />
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute bottom-20 -left-40 w-96 h-96 bg-primary opacity-20 rounded-full blur-3xl animate-pulse" />
      </div>

      <motion.h2
        className="text-4xl md:text-5xl font-extrabold text-center text-primary mb-20"
        variants={card}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.5 }}
      >
        {t('features.heading1')} <span className="text-secondary">Kuizy.ai</span>
      </motion.h2>

      <div className="container grid gap-14 sm:grid-cols-2 lg:grid-cols-3">
        {items.map(({ k, icon: Icon, img, bg }, i) => (
          <motion.div
            key={k}
            className="group relative bg-gray-50 rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow"
            variants={card}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            whileHover={{ scale: 1.03, y: -6 }}
          >
            <div className="h-48 bg-gray-100 flex items-center justify-center">
              <div className="w-full h-full bg-center bg-cover" style={{ backgroundImage: `url('/assets/images/${img}')` }} />
            </div>

            <div className="p-10 flex flex-col items-center text-center">
              <motion.div
                className={`w-20 h-20 mb-6 rounded-full bg-gradient-to-br ${bg} flex items-center justify-center text-white`}
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ type: 'spring', stiffness: 200, damping: 20, delay: i * 0.1 }}
              >
                <Icon size={32} strokeWidth={2.5} />
              </motion.div>

              <h3 className="text-xl md:text-2xl font-semibold mb-3">{t(`features.${k}.title`)}</h3>
              <p className="text-base md:text-lg text-gray-700 leading-relaxed">{t(`features.${k}.desc`)}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  )
}
